import {
    PIE_CHART_CENTER_LABEL_SUBTITLE,
    PIE_CHART_CENTER_LABEL_SUBTITLE_SMALL,
    PIE_CHART_CENTER_LABEL_TITLE,
} from '@wdx/shared/utils';
import { Chart, SVGElement } from 'highcharts';

export function renderTotal(subTitle: string, title = 'Total') {
    return function (this: Chart) {
        const that = this as Chart & {
            centerLabel: SVGElement;
            totalLabel: SVGElement;
        };

        let centerLabel = that.centerLabel as SVGElement;
        let totalLabel = that.totalLabel as SVGElement;
        const plotLeft = that.plotLeft;
        const plotTop = that.plotTop;
        const plotWidth = that.plotWidth;
        const plotHeight = that.plotHeight;

        centerLabel?.destroy();
        totalLabel?.destroy();

        centerLabel = that.renderer
            .text(title, plotLeft + plotWidth / 2, plotTop + plotHeight / 2)
            .css(PIE_CHART_CENTER_LABEL_TITLE)
            .add();
        that.centerLabel = centerLabel;

        if (that.series?.[0]?.points?.length > 0) {
            // highcharts doesn't tell us the available space we have to show our label, so we here
            // we create an estimate to determine when to use smaller text
            const textWidthEstimate = subTitle.length * 11;
            const cssConfig =
                that.chartWidth / 3 < textWidthEstimate
                    ? PIE_CHART_CENTER_LABEL_SUBTITLE_SMALL
                    : PIE_CHART_CENTER_LABEL_SUBTITLE;
            totalLabel = that.renderer
                .text(
                    subTitle,
                    plotLeft + plotWidth / 2,
                    plotTop + plotHeight / 2 + 20
                )
                .css(cssConfig)
                .add();
            that.totalLabel = totalLabel;
        }
    };
}
